export default __webpack_public_path__ + "images/43040c31f74ef349307b861cf00859ff.webp";